import CourseCreationPopup from './courseCreationPopup';
import CourseCreationDetailedPopup from './courseCreationDetailPopup';
import RecommendLinkPopup from './recommendLinkPopup';
import CoursePopup from './coursePopup';
import LinkPopup from './linkPopup';
import AddTrackPopup from './addTrackPopup';
import DeleteTrackPopup from './deleteTrackPopup';
import PeopleDeletePopup from './peopleDeletePopup';
import ChooseRolePopup from './chooseRolePopup';
import ProfilePopup from './profilePopup';
import InvitePeoplePopup from './invitePeoplePopup';
import Crop from './cropPopup';
import PreviewPopup from './previewPopup';
import PricingPopup from './pricingPopup';
import BillingPopup from './billingPopup';
import CurrentPlanPopup from './currentPlanPopup';
import PayForwardPopup from './payForwardPopup';
import CourseRearrange from './courseRearrangePopup';
import LessonCoursePopup from './lessonCoursePopup';

export default class PopupFactory {
  constructor(type, pathQueryMap, detail) {
    // change to else if later
    if (type === 'course-create')
      return new CourseCreationPopup(type, pathQueryMap);
    if (type === 'course-creation-detailed')
      return new CourseCreationDetailedPopup(type, pathQueryMap);
    if (type === 'recommend-popup')
      return new RecommendLinkPopup(type, pathQueryMap);

    if (type === 'course-popup')
      return new CoursePopup(type, pathQueryMap, detail);

    if (type === 'link-popup') return new LinkPopup(type, pathQueryMap);

    if (type === 'add-track-popup')
      return new AddTrackPopup(type, pathQueryMap, detail);

    if (type === 'delete-track')
      return new DeleteTrackPopup(type, pathQueryMap, detail);

    if (type === 'delete-people')
      return new PeopleDeletePopup(type, pathQueryMap);

    if (type === 'choose-role-popup')
      return new ChooseRolePopup(type, pathQueryMap);

    if (type === 'profile-popup') return new ProfilePopup(type, pathQueryMap);

    if (type === 'billing-popup') return new BillingPopup(type, pathQueryMap);

    if (type === 'invite-people')
      return new InvitePeoplePopup(type, pathQueryMap);

    if (type === 'crop') return new Crop(type, pathQueryMap);

    if (type === 'preview-popup') return new PreviewPopup(type, pathQueryMap);

    if (type === 'pricing-popup') return new PricingPopup(type, pathQueryMap);

    if (type === 'current-plan-popup')
      return new CurrentPlanPopup(type, pathQueryMap);

    if (type === 'pay-forward-popup')
      return new PayForwardPopup(type, pathQueryMap);

    if (type === 'course-rearrange')
      return new CourseRearrange(type, pathQueryMap);

    if (type === 'course-lesson-reports')
      return new LessonCoursePopup(type, pathQueryMap);
  }
}
